interface BookInterface {
    id: string;
    book_id: number;
    accommodation_id: number;
    start_date: Date;
    name: string;
    person_number: number;
    price: number;
    created_at: Date;
    payment_limit_date: Date | null;
    updated_at?: Date | null;
}

class Book implements BookInterface {
    id: string;
    book_id: number;
    accommodation_id: number;
    start_date: Date;
    name: string;
    person_number: number;
    price: number;
    created_at: Date;
    payment_limit_date: Date | null;
    updated_at?: Date | null;

    constructor(
        id: string,
        book_id: number,
        accommodation_id: number,
        start_date: Date,
        name: string,
        person_number: number,
        price: number,
        created_at: Date,
        payment_limit_date: Date | null,
        updated_at?: Date | null
    ) {
        this.id = id;
        this.book_id = book_id;
        this.accommodation_id = accommodation_id;
        this.start_date = start_date;
        this.name = name;
        this.person_number = person_number;
        this.price = price;
        this.created_at = created_at;
        this.payment_limit_date = payment_limit_date;
        this.updated_at = updated_at;
    }
}

export default Book;
